import r from "../managers/braze-instance.js";
import je from "./in-app-message-manager-factory.js";
export function subscribeToInAppMessage(n) {
  if (r.rr())
    return "function" != typeof n
      ? null
      : je.ra().Tn(function (r) {
          return n(r[0]), r.slice(1);
        });
}
